import React from 'react';
import { ResponsiveButton } from './index';
import './LoginPrompt.css';

import { AuthMethod } from '../types';

interface LoginPromptProps {
  gamesPlayed: number;
  onLogin: () => void;
  onPostpone: () => void;
  onDismiss: () => void;
  onClose: () => void;
}

export const LoginPrompt: React.FC<LoginPromptProps> = ({
  gamesPlayed,
  onLogin,
  onPostpone,
  onDismiss,
  onClose
}) => {
  return (
    <div className="login-prompt-overlay">
      <div className="login-prompt-modal">
        <div className="login-prompt-header">
          <div className="login-prompt-icon">🎮</div>
          <h3>Enjoying PlayHub Games?</h3>
          <button 
            className="login-prompt-close"
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
        </div>
        
        <div className="login-prompt-content">
          <p className="login-prompt-message">
            You've played <strong>{gamesPlayed} games</strong>! 
            Create an account to save your progress and unlock more features.
          </p>
          
          <div className="login-prompt-benefits">
            <div className="benefit-item">
              <span className="benefit-icon">💾</span>
              <span>Save your game progress</span>
            </div>
            <div className="benefit-item">
              <span className="benefit-icon">🏆</span>
              <span>Track your statistics</span>
            </div>
            <div className="benefit-item">
              <span className="benefit-icon">🎯</span>
              <span>Compete on leaderboards</span>
            </div>
            <div className="benefit-item">
              <span className="benefit-icon">🎨</span>
              <span>Customize your experience</span>
            </div>
          </div>
        </div>
        
        <div className="login-prompt-actions">
          <ResponsiveButton
            variant="primary"
            onClick={onLogin}
            className="login-btn-primary"
          >
            Create Account / Login
          </ResponsiveButton>
          
          <div className="login-prompt-secondary-actions">
            <button
              className="login-btn-postpone"
              onClick={onPostpone}
            >
              Maybe Later (24h)
            </button>
            
            <button
              className="login-btn-dismiss"
              onClick={onDismiss}
            >
              Don't Ask Again
            </button>
          </div>
        </div>
        
        <div className="login-prompt-footer">
          <p>Continue playing as guest or create an account for the full experience!</p>
        </div>
      </div>
    </div>
  );
};

export default LoginPrompt;